import { Box, Divider } from '@mui/material';
import GenerateRaportPZ05 from '../../features/GenerateRaportPZ05/GenerateRaportPZ05';
import { useTranslation } from 'react-i18next';
const ReportsPZ05 = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ marginTop: '50px', ml: { xs: 2, md: 0 } }}>
      <h1>{t('pz05.reportPZ05')}</h1>
      <Divider sx={{ width: '100%', mb: 3, bgcolor: '#C09A53' }} />
      <GenerateRaportPZ05 />
    </Box>
  );
};

export default ReportsPZ05;
